import { createStore as createReduxStore } from 'redux';
import { rootReducer } from '../reducers/combibeReducer';
const defaultState = { loader: true,monthlyLoader :true,hotelList:[] };

const storeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
export const createStore = () => createReduxStore(rootReducer,defaultState, storeEnhancer);
